import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Toast de progresso da IA (inferior direito)
 * Mostra o progresso do processamento do Labor Bill em background
 */
const AIProgressToast = ({ isVisible, progress, currentStep, onClose, isComplete, hasError, queueInfo }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] w-80 animate-in slide-in-from-bottom-2 fade-in duration-300">
      <div className={`
        border-2 rounded-lg shadow-2xl p-4
        ${hasError 
          ? 'bg-red-50 border-red-300' 
          : isComplete 
            ? 'bg-green-50 border-green-300'
            : 'bg-white border-purple-300'
        }
      `}>
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className={isComplete ? '' : hasError ? '' : 'animate-spin'}>
              {hasError ? '❌' : isComplete ? '✅' : '🤖'}
            </div>
            <p className="font-semibold text-sm">
              {hasError 
                ? 'Erro ao processar' 
                : isComplete 
                  ? 'Labor Bill pronto!' 
                  : 'Processando Installation Package'
              }
            </p>
          </div>

          {/* Contador da fila (ex.: 1/3) */}
          {!isComplete && !hasError && queueInfo && (
            <span
              className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 border border-purple-200"
              data-testid="ai-queue-counter"
            >
              {queueInfo}
            </span>
          )}
          
          {(isComplete || hasError) && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="h-6 w-6 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
        
        {/* Status atual */}
        {!hasError && (
          <div className="text-xs text-gray-700 mb-3">
            {currentStep || 'Iniciando...'}
          </div>
        )}
        
        {/* Progress Bar */}
        {!hasError && (
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div 
              className={`h-full transition-all duration-500 ${
                isComplete ? 'bg-green-500' : 'bg-purple-500'
              }`}
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
        
        {/* Mensagem de sucesso */}
        {isComplete && (
          <div className="mt-3 text-xs text-green-700 font-medium">
            Abra o Labor Bill para revisar e aprovar
          </div>
        )}
        
        {/* Mensagem de erro */}
        {hasError && (
          <div className="mt-2 text-xs text-red-700">
            {currentStep || 'Você pode preencher o Labor Bill manualmente'}
          </div>
        )}
      </div>
    </div>
  );
};

export default AIProgressToast;
